import styled from "styled-components";
import { AuthBanner } from "@assets";
import {
  Form as AntForm,
  Divider as AntDivider,
  Input as AntInput,
  Button as AntButton,
  Modal as AntModal,
} from "antd";

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
`;

export const Banner = styled.img.attrs({
  alt: "logo",
  src: AuthBanner,
})`
  width: 100%;
  height: auto;
  object-fit: cover;
  position: relative;
`;

export const Container = styled.div`
  background: linear-gradient(
    28.86deg,
    #c7831f 0.71%,
    #ffb930 12.91%,
    #d99632 33.4%,
    #feae24 52.8%,
    #ffb930 82.35%,
    #c7831f 89.98%,
    #f9a72c 106.61%
  );
  width: 100%;
  /* min-height: 500px; */
  border-radius: 32px 32px 0px 0px;
  position: relative;
  top: -30px;
`;

export const Title = styled.p`
  font-weight: 600;
  padding-top: 40px;
  color: #342309;
  font-size: 20px;
  text-align: center;
`;

export const FormContainer = styled.div`
  padding: 15px 10px;
`;

export const Form = styled(AntForm)`
  width: 100%;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-label {
    padding-left: 10px;
  }

  input {
    border: 1px solid #e1cce0;
    border-radius: 12px;
  }

  input[type="text"],
  input[type="number"] {
    height: 52px;
  }

  input[type="password"] {
    height: 40px;
    font-size: 17px !important;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  font-size: 17px;
`;

export const FilledButton = styled(AntButton)`
  width: 100%;
  color: ${(props) => props.theme.white} !important;
  border: none !important;
  background-color:#000 !important;
  &:hover,
  &:focus {
    background-color: #000 !important;
    color: ${(props) => props.theme.white} !important;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 12px;
  padding: 0 10px;
`;

export const Divider = styled(AntDivider)`
  padding: 0px 30px 12px 30px;
  .ant-divider-inner-text {
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    background: rgba(52, 35, 9, 1);
    border-radius: 100%;
    padding: 3px 8px;
  }

  ::before,
  ::after {
    border: 1px solid #e1cce0;
    border-color: #e1cce0 !important;
  }
`;

export const OutlinedButton = styled.div`
  .ant-btn-default {
    width: 100%;
    color: ${(props) => props.theme.white} !important;
    border-color: #ffffff !important;
    background: none !important;

    :hover {
      color: ${(props) => props.theme.whtie} !important;
      border-color: #ffffff !important;
      background: none !important;
    }
  }
`;

export const BackText = styled.span`
  color: #e8a442;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  position: absolute;
  top: 30px;
  left: 16px;
`;

export const SkipText = styled.span`
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 16px;
`;

export const Modal = styled(AntModal)`
  .ant-modal-content {
    padding: 0;
    padding-top: 15px;
    margin: 0;
  }
  .ant-modal-title {
    text-align: center;
    color: #e9a94d;
    /* color:${(props) => props.theme.golden} !important; */
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 26px;
  }
`;

export const ModalFooterContainer = styled.div`
  height: 52px;
  display: flex;
  border-top: 2px solid #f4f1eb;
  background: ${(props) => props.theme.golden};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textColor};
  border-radius: 0 0 8px 8px;
  cursor: pointer;
`;

export const ModalTitle = styled.p`
  color: ${(props) => props.theme.primarySolid};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const ModalText = styled.p`
  color: #858585;
  font-weight: 400;
  font-size: 14px;
  display: block;
  margin-bottom: 20px;
  padding: 0 30px;
`;

export const GoogleLoginButton = styled.div`
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: linear-gradient(0deg, rgb(52, 46, 33), rgb(0, 0, 0));
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;
color: #fff;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const SpaceBetweenTopBottom = styled.div`
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
justify-content:center;
gap:20px;
align-items:center;
`;

export const TelegramRegisterButton = styled.div`
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: linear-gradient(0deg, rgb(52, 46, 33), rgb(0, 0, 0));
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;
color: #fff;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;